import Head from 'next/head';
import React from 'react';
import { DocsPage } from '../../modules/docs/docs/components';

const Docs = () => {
	return (
		<React.Fragment>
			<Head>
				<title>Dummy API Getting Started</title>
				<meta name="description" content="DummyAPI Rest documentation, getting started with API." />
			</Head>
			<DocsPage />
		</React.Fragment>
	);
};

export default Docs;